<template>
  <div>
    <v-card class="pt-2 ma-2 mt-4" max-width="100%">
      <v-data-table
        dense
        :search="search"
        class="elevation-1"
        :headers="headers"
        :items="expensePending"
        item-key="name"
      >
        <template v-slot:[`item.sl_no`]="{ item }">
          <span class="caption">{{ expensePending.indexOf(item) + 1 }}</span>
        </template>
        <template v-slot:[`item.Name`]="{ item }">
          <span class="caption">{{ item.Name }}</span>
        </template>
        <template v-slot:[`item.description`]="{ item }">
          <span class="caption">{{ item.description }}</span>
        </template>
        <template v-slot:[`item.Address`]="{ item }">
          <span class="caption">{{ item.Address }}</span>
        </template>

        <template v-slot:[`item.NatureOfPayment`]="{ item }">
          <span class="caption">{{ item.NatureOfPayment }}</span>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <div v-if="item.status == '2'">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on" class="caption orange--text font-weight-medium"
                  >PENDING</span
                >
              </template>
              <span>PENDING FOR APPROVAL</span>
            </v-tooltip>
          </div>
          <div v-if="item.status == '1'">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on" class="caption green--text font-weight-medium"
                  >APPROVED</span
                >
              </template>
              <span>APPROVED</span>
            </v-tooltip>
          </div>
          <div v-if="item.status == '3'">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on" class="caption red--text font-weight-medium"
                  >REJECTED</span
                >
              </template>
              <span>REJECTED</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                @click="showContent(item)"
                small
                class="mr-2"
                v-on="on"
                color="primary"
                >mdi-pencil</v-icon
              >
            </template>
            <span>view details</span>
          </v-tooltip>
        </template>
        <template v-slot:top>
          <v-layout row wrap>
            <v-row class="ml-2">
              <v-col cols="3">
                <v-card-title class="primary--text mr-n5">
                  Expense Classification
                  <v-divider vertical class="ml-5 mx-0"></v-divider>
                </v-card-title>
              </v-col>
              <v-spacer></v-spacer>
              <v-col lg="3" class="mt-3">
                <v-text-field
                  dense
                  shaped
                  outlined
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="mt-3 mr-4">
                <v-dialog persistent v-model="createVendor" width="600">
                  <v-toolbar dark class="gradient-bg2" dense>
                    <v-toolbar-title class="white--text titcss"
                      >Create Expense Classification</v-toolbar-title
                    >

                    <v-spacer></v-spacer>
                    <v-btn class text dark @click="createVendor = false">
                      <v-icon color="white">mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <template #activator="{ on: createVendor }">
                    <v-tooltip bottom color="primary">
                      <template #activator="{ on: tooltip }">
                        <v-btn
                          class="primary white--text"
                          v-on="{ ...createVendor, ...tooltip }"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span class="white--text"
                        >Create Expense Classification</span
                      >
                    </v-tooltip>
                  </template>
                  <v-card>
                    <v-divider></v-divider>
                    <v-form ref="formDept">
                      <v-row class="ma-2">
                        <v-col cols="12">
                          <v-text-field
                            v-model="Name"
                            label="Name*"
                            color="primary"
                            :rules="nameRules"
                            required
                            outlined
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="mt-n4">
                          <v-text-field
                            v-model="descriptionEX"
                            color="primary"
                            :rules="nameRules"
                            label="Description*"
                            required
                            outlined
                            dense
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          rounded
                          class="primary white--text mr-3 mb-2 mt-n8"
                          :loading="isLoading"
                          medium
                          @click="createDepartment"
                        >
                          <v-icon>mdi-plus</v-icon>Add
                        </v-btn>
                      </v-card-actions>
                    </v-form>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
          </v-layout>
        </template>
      </v-data-table>
    </v-card>

    <OverleyProccessg :overlay="overlay" />
  </div>
</template>
<script>
//import ApproveViewDetailsCust from "@/components/CustomerSubfolder/ApproveViewDetailsCust.vue";
import OverleyProccessg from "@/Views/OverleyProccessg.vue";
import moment from "moment";
//import { apiCall } from "@/Views/APICALL/APIcall.js";
export default {
  components: {
    OverleyProccessg,
  },
  data: () => ({
    createVendor: false,
    natureRow: "One Time",
    rowVendor: "Regular Vendor",
    descriptionEX: "",
    receiptStatus: false,
    arraylistStatus: false,
    contentDialog: false,
    start_date: null,
    end_date: new Date().toISOString().substr(0, 10),

    workflowType: "Customer Onboarding",
    expensePending: [
      {
        Name: "Travel",
        description: "Traveling within 200KM",
        Address: "Bangalore",
        NatureOfPayment: "Ragular",
        created_on: "20-01-2020",
      },
      {
        Name: "Food",
        description: "Fooding for 7 people",
        Address: "Bangalore",
        NatureOfPayment: "One Time",
        created_on: "20-01-2020",
      },
    ],

    headers: [
      {
        text: "SL NO",
        align: "start",
        sortable: false,
        value: "sl_no",
      },
      // align: ' d-none'
      {
        text: "NAME",
        align: "start",
        sortable: false,
        value: "Name",
      },

      {
        text: "DESCRIPTION",
        value: "description",
        align: "start",
        sortable: false,
      },

      {
        text: "Due Date",
        value: "created_on",
        align: "start",
        sortable: false,
      },

      { text: "", value: "actions", align: "start", sortable: false },
    ],
    overlay: false,
    search: "",
    itemfield: "",
  }),
  created() {},
  methods: {
    callstatus() {
      this.receiptStatus = false;
      this.getExpenseApprData();
    },

    getFileName(filename) {
      //  console.log("vvv", filename);
      var url = filename.split("/");
      var len = url.length;
      const sample = url[len - 1];
      return sample;
    },
    convertDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>
